import React, { useState, useEffect, useContext } from "react";
import { useParams } from "react-router-dom";
import ReactMarkdown from "react-markdown";
import StyleContext from "../../contexts/StyleContext";
import "./BlogPage.scss";

export default function BlogPage() {
  const { isDark } = useContext(StyleContext);
  const { blogId } = useParams();
  const [markdownContent, setMarkdownContent] = useState("");
  const [blogTitle, setBlogTitle] = useState("");

  const resolveImagePath = (src) => {
    const filename = src.split("/").pop();
    try {
      return require(`../../assets/images/${filename}`);
    } catch (e) {
      console.error(`Image not found: ${filename}`, e);
      return null;
    }
  };

  useEffect(() => {
    const loadMarkdown = async () => {
      try {
        const response = await fetch(`/blogsmd/${blogId}/${blogId}.md`);
        if (response.ok) {
          const text = await response.text();
          setMarkdownContent(text);
          // Extract title from markdown (first line starting with # )
          const lines = text.split("\n");
          const firstLine = lines.find(line => line.trim().startsWith("# "));
          if (firstLine) {
            setBlogTitle(firstLine.replace("# ", "").trim());
          } else {
            // Fallback to capitalized blogId
            setBlogTitle(
              blogId
                .split("-")
                .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
                .join(" ")
            );
          }
        } else {
          console.error(`Fetch failed for blog: ${response.status}`);
          setMarkdownContent("Error loading blog content.");
          setBlogTitle("Page Not Found");
        }
      } catch (error) {
        console.error(`Failed to load blog: ${error}`);
        setMarkdownContent("Error loading blog content.");
        setBlogTitle("Error");
      }
    };

    if (blogId) {
      loadMarkdown();
    }
  }, [blogId]);

  console.log("Rendered Title:", blogTitle); // Debug log

  return (
    <div className={isDark ? "blog-page dark-mode" : "blog-page"}>
      <div className="blog-page-container">
        <div className="blog-page-header">
          <h1 key={blogId} className={isDark ? "blog-page-title dark-mode" : "blog-page-title"}>
            {blogTitle}
          </h1>
        </div>
        <div className="blog-content">
          <ReactMarkdown
            className={isDark ? "markdown-content dark-mode" : "markdown-content"}
            components={{
              h1: ({ node, ...props }) => null, // Skip rendering <h1> from markdown
              img: ({ src, alt }) => {
                const imagePath = resolveImagePath(src);
                return imagePath ? (
                  <img src={imagePath} alt={alt} style={{ maxWidth: "100%" }} />
                ) : (
                  <span>Image not found: {alt}</span>
                );
              },
            }}
          >
            {markdownContent}
          </ReactMarkdown>
        </div>
      </div>
    </div>
  );
}